import React, { useState, useEffect, useRef } from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import CategoryLink from '@jetshop/ui/CategoryLink';
import CloseButton from '../../../ui/CloseButton';
import t from '@jetshop/intl';
import { theme } from '../../../Theming/Theming';
import { headerTransitions } from './DesktopHeader';
import { config } from '../../../../shop.config.custom';

const boxShadow = `
  box-shadow: 0px 3px 4px #00000012;
`;

const SubMenuWrapper = styled('div')`
  display: none;
  max-height: calc(100vh - ${theme.header.height.lg + 'px'});
  overflow: auto;
  overflow-x: hidden;
  background: white;
  z-index: 2;
  ${headerTransitions}
  //DIFFERENT TYPES
  &.vertical {
    top: ${theme.desktopHeader.height.lg + 'px'};
    ${theme.only.md} {
      top: ${theme.desktopHeader.height.md + 'px'};
    }
    position: absolute;
    width: 300px;
    left: 0;
    &[data-scrolling='true'] {
      top: ${theme.desktopHeader.height.scroll + 'px'};
    }
    .sub-menu-inner-wrapper {
      padding: 1rem ${theme.desktopHeader.nav.padding[0]};
      ${theme.above.xl} {
        padding: 1rem ${theme.desktopHeader.nav.padding[1]};
      }
    }
  }
  &.mega-menu {
    position: fixed;
    width: 100%;
    left: 0;
    top: ${theme.desktopHeader.height.lg + theme.topBar.height.lg + 'px'};
    ${boxShadow}
    ${theme.only.md} {
      top: ${theme.desktopHeader.height.md + +theme.topBar.height.md + 'px'};
    }
    &[data-scrolling='true'] {
      top: ${theme.desktopHeader.height.scroll + 'px'};
    }
    .sub-menu-inner-wrapper {
      padding: 2rem 3rem;
    }
  }
`;

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  right: 1rem;
  top: 1.3rem;
  z-index: 2;
  svg {
    width: 10px;
    height: 10px;
  }
`;

const SubMenuContent = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  position: relative;
  .sub-menu-categories {
    width: 100%;
  }
  .sub-menu-products {
    //width: 70%;
  }
  .borders {
    > div {
      position: absolute;
      top: 0;
      height: 100%;
      border-right: 1px solid ${theme.colors.border};
    }
  }
`;

const SubMenuCategories = styled('div')`
  opacity: 0;
  transition: all 0.2s;
  //LEVEL2
  > ul {
    margin: 0 0;
    padding: 0;
    > li {
      list-style: none;
      -webkit-column-break-inside: avoid; /* Chrome, Safari */
      page-break-inside: avoid; /* Theoretically FF 20+ */
      break-inside: avoid-column; /* IE 11 */
      display: table; /* Actually FF 20+ */
      //LEVEL3
      > ul {
        > li {
          > a {
          }
          //LEVEL4
          > ul {
            display: none;
            > li {
            }
          }
        }
      }
    }
  }
  li.open {
    > ul {
      display: block !important;
    }
  }
  li.show-all > a {
    //color: ${theme.colors.primary};
    //font-weight: ${theme.weights.bold};
    text-decoration: underline;
  }
  a:hover {
    text-decoration: underline;
  }

  //DIFFERENT TYPES
  &.vertical {
    > ul {
      flex-direction: column;
      > li {
        width: 100%;
        line-height: 2.4em;
        > a {
          font-size: ${theme.desktopHeader.nav.subMenu.lv3.fontSize};
        }
        //LEVEL3
        > ul {
          display: none;
        }
      }
    }
  }
  &.mega-menu {
    > ul {
      columns: 3;
      display: block;
      > li {
        width: 100%;
        margin: 0 0;
        > a {
          font-size: ${theme.desktopHeader.nav.subMenu.lv2.fontSize};
          font-weight: ${theme.weights.bold};
          margin-bottom: 0.5rem;
          display: block;
        }
        //LEVEL3
        > ul {
          margin-bottom: 2rem;
          > li {
            line-height: 1.6em;
            > a {
              font-size: ${theme.desktopHeader.nav.subMenu.lv3.fontSize};
            }
            //LEVEL 4
            > ul {
              display: none;
            }
          }
        }
      }
    }
  }
  &[data-brands='true'] {
    > ul {
      columns: 5;
      display: block;
      > li {
        margin: 5px;
        > a {
          text-transform: none;
        }
      }
    }
  }
`;

const SubMenuTitle = styled('h2')`
  text-align: left;
  width: 100%;
  clear: both;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem !important;
  display: flex;
  align-items: baseline;
  text-transform: none;
  a {
    margin-left: 1rem;
    text-decoration: underline !important;
    text-transform: none;
  }
`;
const SubMenuTitleName = styled('span')``;

const SubMenuBackground = styled('div')`
  //transition: all 0.2s;
  position: fixed;
  z-index: -1;
  width: 100%;
  left: 0;
  background: white;
  ${boxShadow}
  top: ${theme.desktopHeader.height.lg + theme.topBar.height.lg + 'px'};
  ${theme.only.md} {
    top: ${theme.desktopHeader.height.md + +theme.topBar.height.md + 'px'};
  }
  &[data-scrolling='true'] {
    top: ${theme.desktopHeader.height.scroll + 'px'};
  }
`;

const ShowAll = styled(CategoryLink)`
  margin-top: 0.5rem;
  display: block;
  font-size: ${theme.desktopHeader.nav.subMenu.lv3.fontSize};
`;

const SubCategories = ({
  mainCategory,
  level,
  setActiveCategory,
  setSubMenu,
  toggleMenu,
  setToggleMenu,
}) => {
  let limiter = 200;
  if (level >= 3) limiter = 5;
  if (mainCategory.subcategories.length)
    return (
      <ul>
        {mainCategory.subcategories.map((category, index) => (
          <React.Fragment key={category.id}>
            {index <= limiter && (
              <li className={category.id === toggleMenu ? 'open' : ''}>
                <CategoryLink
                  onClick={() => {
                    setSubMenu(false);
                    setActiveCategory(category);
                  }}
                  category={category}
                >
                  {category.name}
                </CategoryLink>
                {category.subcategories &&
                  category.subcategories.length > 0 && (
                    <SubCategories
                      mainCategory={category}
                      level={level + 1}
                      setActiveCategory={setActiveCategory}
                      setSubMenu={setSubMenu}
                      toggleMenu={toggleMenu}
                      setToggleMenu={setToggleMenu}
                    />
                  )}
              </li>
            )}
          </React.Fragment>
        ))}
        {level === 3 && (
          <li className="show-all">
            <CategoryLink
              onClick={() => {
                setSubMenu(false);
                setActiveCategory(mainCategory);
              }}
              category={mainCategory}
            >
              {t('Show all')}
            </CategoryLink>
          </li>
        )}
      </ul>
    );
  else return null;
};

const SubMenu = ({ category, setActiveCategory, setSubMenu, scrolling }) => {
  const [toggleMenu, setToggleMenu] = useState(0);

  const [menuHeight, setMenuHeight] = useState(100);

  const subMenuRef = useRef();
  const isBrandCat = category.id === config.routes.brand.id;

  let subMenuType = 'mega-menu'; //vertical || mega-menu

  if (isBrandCat) subMenuType = 'mega-menu';

  //CHECK FOR LEVEL3 THEN SHOW MEGAMENU (DYNAMIC)
  /*
  const level3min = 3;
  let level3count = 0;

  if (category.subcategories.length > 2) subMenuType = 'mega-menu';
  else {
    for (let i = 0; i < category.subcategories.length; i++) {
      const subCategory = category.subcategories[i];
      if (
        subCategory &&
        subCategory.subcategories &&
        subCategory.subcategories.length > 0
      ) {
        level3count++;
        if (level3count === level3min) {
          subMenuType = 'mega-menu';
          break;
        }
      }
    }
  }*/
  useEffect(() => {
    //SETS BACKGROUND HEIGHT
    if (menuHeight !== (subMenuRef.current && subMenuRef.current.clientHeight))
      setMenuHeight(subMenuRef.current.clientHeight);
  }, [menuHeight, setMenuHeight]);

  useEffect(() => {
    //CLOSE OUTSIDE LISTENER
    const listener = (event) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setSubMenu(false);
      }
    };
    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [subMenuRef, setSubMenu]);

  if (category && category.subcategories && category.subcategories.length) {
    return (
      <SubMenuWrapper
        data-scrolling={scrolling}
        className={cx('sub-menu-wrapper', subMenuType)}
      >
        <div ref={subMenuRef} className="sub-menu-inner-wrapper">
          <StyledCloseButton onClick={() => setSubMenu(false)} />
          {subMenuType === 'mega-menu' && (
            <SubMenuTitle>
              <SubMenuTitleName>{category.name}</SubMenuTitleName>
              <CategoryLink
                category={category}
                onClick={() => {
                  setActiveCategory(category);
                  setSubMenu(false);
                }}
              >
                <p>{t('Go to category')}</p>
              </CategoryLink>
            </SubMenuTitle>
          )}
          <SubMenuContent>
            {subMenuType === 'vertical' && (
              <SubMenuBackground
                data-scrolling={scrolling}
                style={{
                  height: menuHeight,
                }}
              />
            )}
            <SubMenuCategories
              className={cx('sub-menu-categories', subMenuType)}
              data-brands={isBrandCat}
              style={{
                opacity: menuHeight && 1,
              }}
            >
              <SubCategories
                mainCategory={category}
                level={2}
                setActiveCategory={setActiveCategory}
                setSubMenu={setSubMenu}
                toggleMenu={toggleMenu}
                setToggleMenu={setToggleMenu}
              />
            </SubMenuCategories>
            <div className="borders">
              {Array.from(Array(3).keys()).map((index) => (
                <div
                  key={index}
                  style={{ left: `calc(${(100 / 3) * (index + 1)}% - 1rem` }}
                />
              ))}
            </div>
          </SubMenuContent>
          {subMenuType === 'vertical' && (
            <ShowAll
              className="show-all"
              category={category}
              onClick={() => {
                setActiveCategory(category);
                setSubMenu(false);
              }}
            >
              {t('Show all')}
            </ShowAll>
          )}
        </div>
      </SubMenuWrapper>
    );
  } else return null;
};

export default SubMenu;
